template.component.tabs = function() {

	const $tab = $('.tab'),
		tab = '.tab',
		$tab_first = $('.tab[data-tab=tab-1]'),
		$tab_content = $('.tab-content'),
		$hero_tab_content = $('.hero__main .tab-content'),
		$tab_content_first = $('#tab-1'),
		activeClass = 'active',
		flexible = 'tab-content--flexible';
		// window_width = window.innerWidth;

	$tab.removeClass(activeClass);
	$tab_first.addClass(activeClass);
	$tab_content.css('display', 'none');

	if($tab_content_first.hasClass(flexible)) {
		$tab_content_first.css('display', 'flex');
	} else {
		$tab_content_first.css('display', 'block');
	}

	$tab_first
		.attr('aria-selected', 'true')
		.attr('aria-expanded', 'true');
	$tab_content_first.attr('aria-hidden', 'false');

	const change_tab_swipe = function(target) {

		const $tab_related = $('.tab[data-tab=' + target + ']'),
			$tab_content_related = $('#' + target);

		$tab.removeClass(activeClass);
		$tab_content.css('display', 'none');

		$tab
			.attr('aria-selected', 'false')
			.attr('aria-expanded', 'false');
		$tab_content.attr('aria-hidden', 'true');

		$tab_related.addClass(activeClass);
		if($tab_content_related.hasClass(flexible)) {
			$tab_content_related.css('display', 'flex');
		} else {
			$tab_content_related.css('display', 'block');
		}

		$tab_related
			.attr('aria-selected', 'true')
			.attr('aria-expanded', 'true');
		$tab_content_related.attr('aria-hidden', 'false').focus();

		// $('html, body').animate({
		// 	scrollTop: $tab_content_related.offset().top
		// }, 400);

	};

	$tab.click(function() {

		const $tab_number = $(this).data('tab');

		change_tab_swipe($tab_number);

	});

	if($('body.home').length) {

		$hero_tab_content.hammer().bind('swipeleft swiperight', function(e) {

			e.preventDefault();

			const swipe_type = e.type;

			if(swipe_type === 'swiperight') {

				if(e.target.previousElementSibling) {
					change_tab_swipe(e.target.previousElementSibling.id);
				}

			} else if(swipe_type === 'swipeleft') {

				if(e.target.nextElementSibling) {
					change_tab_swipe(e.target.nextElementSibling.id);
				}
			}

		});

	}

	// Enable space and enter for click
	$(document).keydown(function(objEvent) {
		if (objEvent.keyCode === 13 || objEvent.keyCode === 32) {
			$(tab + ':focus').click();
		}
	});

};
